import React, {FC, useMemo, useState} from 'react'
import {DateRangeType, LoadingState} from '../../../../global'
import {useNaturalReferencingData, usePeriod} from '../../../features'
import {DATE_RANGE} from '../../../@components'
import {
    initialValuesNaturalReferencingAcquisition,
    initialValuesNaturalReferencingAudienceView,
    initialValuesNaturalReferencingContent,
    initialValuesNaturalReferencingViewByGeography,
    NaturalReferencingContext,
    NaturalReferencingDataState,
} from '../../../@types'
import {useQuery} from 'react-query'
import {Get} from '../../../../setup'
import {DEFAULT_DATE_RANGE} from '../../../@types/global'

const SEO = process.env.REACT_APP_STATISTICS_SEO || 'statistics-seo'

const NaturalReferencingProvider: FC = ({children}) => {

    const [selectedDateRange, setSelectedDateRange] = useState<DateRangeType>(DEFAULT_DATE_RANGE)
    const period = usePeriod(selectedDateRange)
    const {data, loading} = useNaturalReferencingData({period})
    const handleDateRangeChange = (dateRange: DateRangeType) => {
        setSelectedDateRange(dateRange)
    }


    return (
        <NaturalReferencingContext.Provider
            value={data}>
            <div className="row d-flex justify-content-end align-items-end mb-10">
                <div className="col-12 col-lg-4 d-flex justify-content-end align-items-end mb-5 mb-md-0">
                    <DATE_RANGE onDateRangeChange={handleDateRangeChange}
                                loading={loading}
                                setLoading={() => {}}
                    />
                </div>
            </div>
            {children}
        </NaturalReferencingContext.Provider>
    )
}

export {NaturalReferencingProvider}